import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgNote = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 30,
	height: 20,
	fill: "none",
	viewBox: "0 0 17 17",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "#111",
		fillRule: "evenodd",
		d: "M1 0H0v9.3l.3.3 6 6.1.3.3H16V0H1zm1 8V2h12v12H8V8H2zm1.5 2L6 12.6V10H3.5z",
		clipRule: "evenodd"
	})
});
export default SvgNote;
